import { Typography } from "@circle-react-uikit/Typography";

export const LineItemSm = ({ title, amount, color = "text-default" }: any) => (
  <div className="mb-2 flex items-start justify-between">
    <Typography.BodySm color="text-light">{title}</Typography.BodySm>
    <Typography.BodySm color={color}>{amount}</Typography.BodySm>
  </div>
);
